import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import FormInputText from '../_shared/forms/FormInputText';
import SubmitButton from '../_shared/SubmitButton';
import { snakeCaseToTitle } from '../../utils/Helpers';

class RequestPoForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            purchase_order_number: '',
            loading: false,
            complete: false,
            errors: {},
        };
    }

    handleChange = (e) => {
        const { name, value, type } = e.target;
        let errorsObject = { ...this.state.errors };
        delete errorsObject[name];
        this.setState({
            [name]: type === 'checkbox' ? !this.state[name] : value,
            errors: errorsObject,
        });
    };

    onSubmit = (e) => {
        e.preventDefault();

        if (!this.validate()) return;

        this.setState({ loading: true });
        axios
            .post(this.props.submitRoute, {
                purchase_order_number: this.state.purchase_order_number,
            })
            .then((res) => {
                this.setState({ loading: false, complete: true });
                toastr.success('Purchase order number was successfully submitted');
                
            })
            .catch((err) => {
                console.error(err);
                this.setState({ loading: false });
                toastr.error('Something went wrong. Please try again.');
            });
    };

    validate = () => {
        let errors = {};
        const fields = ['purchase_order_number'];

        fields.forEach((field) => {
            if (!this.state[field]) {
                errors[field] = `${snakeCaseToTitle(field).replace('id', '')} field is required`;
            }
        });

        this.setState({ errors, loading: false });

        if (Object.keys(errors).length > 0) {
            toastr.error('Please fill in all required fields');
        }

        return Object.keys(errors).length === 0;
    };

    render() {
        const { job, customer, customerContact } = this.props;

        return (
            <div>
                <div>
                    <h4>Job Details</h4>
                    <ul>
                        <li>
                            <strong>Customer:</strong> {customer?.name || 'N/A'}
                        </li>
                        <li>
                            <strong>Customer Contact:</strong> {customerContact?.first_name || ''}{' '}
                            {customerContact?.last_name || ''}
                            {!customerContact?.first_name && !customerContact?.last_name && 'N/A'}
                        </li>
                        <li>
                            <strong>Job ID:</strong> {job?.id || 'N/A'}
                        </li>
                        <li>
                            <strong>Job Description:</strong> {job?.job_type?.name || 'No description provided'}
                        </li>
                        <li>
                            <strong>Estimated Price:</strong> {job?.formatted_price || 'N/A'}
                        </li>

                        <li>
                            <strong>Address Line 1:</strong> {job?.address_line_1 || 'N/A'}
                        </li>
                        <li>
                            <strong>Address Line 2:</strong> {job?.address_line_2 || 'N/A'}
                        </li>
                        <li>
                            <strong>City:</strong> {job?.city || 'N/A'}
                        </li>
                        <li>
                            <strong>Postcode:</strong> {job?.postcode || 'N/A'}
                        </li>
                    </ul>
                </div>

                {job.purchase_order_number ? (
                    <div className="alert alert-warning" role="alert">
                        This job already has a purchase order number: <strong>{job.purchase_order_number}</strong>.
                    </div>
                ) : this.state.complete ? (
                    <div className="alert alert-success" role="alert">
                        Thank you! Your purchase order number has been submitted successfully.
                    </div>
                ) : (
                    <form onSubmit={this.onSubmit} className="transform-text">
                        <div className="row">
                            <div className="form-group col-md-4">
                                <FormInputText
                                    type="text"
                                    label="Purchase order number"
                                    name="purchase_order_number"
                                    value={this.state.purchase_order_number}
                                    classes="form-control"
                                    handleChange={this.handleChange}
                                    error={this.state.errors.purchase_order_number}
                                />
                            </div>
                        </div>
                        <SubmitButton
                            buttonText="Submit"
                            loading={this.state.loading}
                            style={{ width: 200, marginTop: 50 }}
                        />
                    </form>
                )}
            </div>
        );
    }
}

if (document.getElementById('requestPo')) {
    const element = document.getElementById('requestPo');

    ReactDOM.render(
        <RequestPoForm
            job={JSON.parse(element.dataset.job)}
            customer={JSON.parse(element.dataset.customer)}
            customerContact={JSON.parse(element.dataset.customerContact)}
            submitRoute={element.dataset.submitRoute}
        />,
        element
    );
}

export default RequestPoForm;
